{
	"$schema": "http://json-schema.org/draft-07/schema#",
	"title": "Datenanfragen.de supervisory authority database record",
	"description": "A single record of the Datenanfragen.de supervisory authority database. It represents the contact information of an authority specifically for lodging complaints.\nMore information and access to the whole database at: https://github.com/datenanfragen/data",
	"type": "object",
	"properties": {
		"slug": {
			"type": "string",
			"title": "Slug",
			"pattern": "^[a-z0-9-]+$",
			"description": "A unique identifier for the supervisory authority record. Also defines the filename."
		},
		"relevant-countries": {
			"type": "array",
			"title": "Relevant countries",
			"description": "A list of countries the record is relevant for. The countries can either be an ISO 3166-1 alpha-2 country code or 'all'. If a supervisory authority offers its services in English and isn't explicitly restricted to certain countries, 'all' should be specified.",
			"uniqueItems": true,
			"items": {
				"type": "string",
				"pattern": "^([a-z]{2}|all)$"
			}
		},
		"name": {
			"type": "string",
			"description": "The official name of the authority.",
			"title": "Name"
		},
		"address": {
			"type": "string",
			"title": "Address",
			"description": "The address where the authority can be reached to lodge complaints. Has to include the country (either in the country's native language or in English) in the last line and should be formatted according to the standards of the respective country.",
			"format": "text"
		},
		"phone": {
			"type": "string",
			"title": "Phone",
			"description": "A phone number where the authority can be reached for privacy-related inquires and complaints. Has to be in the standard international format and include the country code.",
			"pattern": "^\\+\\d+ \\d+ [\\d ]+$"
		},
		"fax": {
			"type": "string",
			"title": "Fax",
			"description": "A fax number where the authority can be reached for privacy-related inquires and complaints. Has to be in the standard international format and include the country code.",
			"pattern": "^\\+\\d+ \\d+ [\\d ]+$"
		},
		"email": {
			"type": "string",
			"title": "Email",
			"description": "An email address where the authority can be reached to lodge complaints. Preferably a specific complaint@[domain.tld] address if available.",
			"format": "idn-email"
		},
		"webform": {
			"type": "string",
			"title": "Web form",
			"description": "A URL to a web form that can be used to lodge complaints with the authority. This should only be used for web forms specifically for complaints. General contact forms should only be entered here in rare cases, e.g. if the authority has neither an email address nor a complaint web form.",
			"format": "uri"
		},
		"pgp-fingerprint": {
			"type": "string",
			"title": "PGP fingerprint",
			"description": "Fingerprint of the PGP key of the email address used to lodge complaints with the authority. The PGP key should be found by this key on public keyservers. Please check the key thoroughly before entering it.",
			"pattern": "^([0-9A-F]{4} ){5}( [0-9A-F]{4}){5}$"
		},
		"pgp-url": {
			"type": "string",
			"title": "PGP URL",
			"description": "URL, where the PGP key of the email address used to lodge complaints with the authority can be downloaded. The protocol *must* be https and the domain has to belong to the repective authority. Please check the key thoroughly before entering it.",
			"format": "uri"
		},
		"web": {
			"type": "string",
			"title": "Website",
			"description": "The authority's main website.",
			"format": "uri"
		},
		"sources": {
			"type": "array",
			"title": "Sources",
			"description": "A list of sources for the record. Preferably from the authority's official website.",
			"uniqueItems": true,
			"items": {
				"type": "string",
				"format": "uri"
			}
		},
		"complaint-language": {
			"type": "string",
			"title": "Complaint language",
			"description": "The language complaint to the authority should be in. Has to be an ISO 639-1 language code. If not specified, fallback to the interface language.",
			"pattern": "^[a-z]{2}$"
		},
		"suggested-transport-medium": {
			"type": "string",
			"title": "Suggested transport medium",
			"description": "The transport medium a user should use for their privacy-related inquires and requests. If a PGP key is available, 'email' should be specified. The default is a fallback chain as follows: fax -> letter -> email.",
			"enum": [ "fax", "letter", "email" ]
		},
		"comments": {
			"type": "array",
			"title": "Comments",
			"description": "A list of notes relevant to the record.",
			"items": {
				"type": "string",
				"format": "text"
			}
		}
	},
	"additionalProperties": false,
	"required": [ "slug", "relevant-countries", "name", "address", "sources" ]
}
